<template>
  <div class="w-full sm:w-1/2 lg:w-1/3 px-2 mb-4">
    <v-card class="stat-card" flat>
      <div v-if="title != 'Credited'" class="stat-header">
        <div>
          <div class="stat-title">{{ title }}</div>
          <div v-if="!tooltiptext" class="stat-value">{{ value || '-' }}</div>
          <div v-else class="stat-value">
              <v-tooltip top color="primary">
                  <template #activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" >{{ value || '-' }}</span>
                  </template>
                  <span>{{ tooltiptext }}</span>
              </v-tooltip>
          </div>
        </div>

        <v-icon class="stat-icon">{{ icon }}</v-icon>
      </div>

      <div v-else>
        <div class="stat-header">
          <div>
            <div class="stat-title">{{ title }}:</div>
            <div class="stat-value">
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ value || '-' }} <span style="font-size: 18px;"> - ${{ refunds_amount}}</span>
                    </span>
                </template>

                <span>
                    Total Credited Leads for the selected month
                </span>
              </v-tooltip>

            </div>
          </div>

          <div>
            <div class="stat-title">Total:</div>
            <div class="stat-value">
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ total_refunds || '-' }} <span style="font-size: 18px;"> - ${{ refunds_amount_total}}</span>
                    </span>
                </template>

                <span>
                    Total Credited Leads since we started submitting your surveys
                </span>
              </v-tooltip>
            </div>
          </div>

          <v-icon class="stat-icon">{{ icon }}</v-icon>
        </div>
      </div>

      <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <span
                  class="stat-change"
                  :class="changeClass"
                >
                  <v-icon small>
                    {{ changeIcon }}
                  </v-icon>
                  {{ change }}%
                </span>
              </div>
          </template>

          <span>
              <span v-if="changeClass == 'up'">
                Shows increase compared to last month
              </span>

              <span v-if="changeClass == 'down'">
                Shows decrease compared to last month
              </span>
          </span>
        </v-tooltip>

    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
    value: [String, Number],
    current: [String, Number],
    previous: [String, Number],
    change: [String, Number],
    total_refunds: [String, Number],
    refunds_amount: [String, Number],
    refunds_amount_total: [String, Number],
    tooltiptext: [String],
    reverse: Boolean
  },
  computed: {
    isDown () {
      return this.reverse
        ? this.current > this.previous
        : this.current < this.previous
    },
    changeClass () {
      return this.isDown ? 'down' : 'up'
    },
    changeIcon () {
      return this.isDown ? 'mdi-arrow-down' : 'mdi-arrow-up'
    }
  }
}
</script>

<style scoped>
.stat-group-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #111827;
}

.stat-card {
  border-radius: 14px;
  padding: 16px;
  background: #f4f7ff;
}

.stat-header {
  display: flex;
  justify-content: space-between;
}

.stat-title {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.stat-value {
  font-size: 26px;
  font-weight: 700;
  color: #111827;
  margin-top: 4px;
}

.stat-icon {
  background: #d4daf4;
  padding: 8px;
  padding-top: 0px;padding-bottom: 0px;
  height: 40px;
  border-radius: 10px;
  color: #4f46e5;
}

.stat-change {
  margin-top: 8px;
  font-size: 12px;
}

.stat-change.up {
  color: #16a34a;
  cursor: ne-resize;
}

.stat-change.down {
  color: #dc2626;
  cursor: sw-resize;
}
</style>